import { PriceChart } from "../components/PriceChart";

export function ChartPage() {
  return (
    <div className="page page-chart">
      <h1 className="page-title">7 天金價走勢</h1>
      <PriceChart />
    </div>
  );
}

